// extracted by mini-css-extract-plugin
export var container = "style-module--container--87f08";
export var desc = "style-module--desc--a726b";
export var form = "style-module--form--50456";
export var info = "style-module--info--b392c";
export var neuro = "style-module--neuro--e1915";
export var policy = "style-module--policy--aec10";
export var sub = "style-module--sub--83119";